import React from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../../components/ui/alert-dialog";

/**
 * KND-2 — "Kündigung zurücknehmen?"
 *
 * The confirm button does NOT close the dialog by itself (Radix closes an
 * AlertDialogAction on click): the withdrawal is pessimistic, so the dialog
 * stays until the server has answered. The container closes it on success
 * and leaves it open on a refusal, so "Abbrechen" is still one click away.
 */
export default function WithdrawTerminationDialog({
  open,
  busy = false,
  onOpenChange,
  onConfirm,
  onCloseAutoFocus,
}) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (busy) return;
        onOpenChange(next);
      }}
    >
      <AlertDialogContent onCloseAutoFocus={onCloseAutoFocus}>
        <AlertDialogHeader>
          <AlertDialogTitle>Kündigung zurücknehmen?</AlertDialogTitle>
          <AlertDialogDescription>
            Die aktive Kündigung wird zurückgenommen und das ursprüngliche
            Vertragsende wiederhergestellt.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy}>Abbrechen</AlertDialogCancel>
          <AlertDialogAction
            disabled={busy}
            onClick={(event) => {
              event.preventDefault();
              onConfirm();
            }}
            // Foreground text on the dialog surface, the destructive colour as
            // the border: white on `--destructive` measures 4.37:1 (light) and
            // 3.61:1 (dark), under the 4.5:1 a label needs (WCAG AA).
            className="border border-destructive bg-transparent text-foreground shadow-none hover:bg-destructive/10 focus-visible:ring-destructive"
          >
            {busy ? "Wird ausgeführt …" : "Kündigung zurücknehmen"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
